/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Not_FoundInputs */

const en_svc_not_found = /** @type {(inputs: Svc_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service Not Found!`)
};

const ar_svc_not_found = /** @type {(inputs: Svc_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الخدمة غير موجودة!`)
};

const bn_svc_not_found = /** @type {(inputs: Svc_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোনো সার্ভিস মেলেনি!`)
};

const de_svc_not_found = /** @type {(inputs: Svc_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienst nicht gefunden!`)
};

const es_svc_not_found = /** @type {(inputs: Svc_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Servicio no encontrado!`)
};

const fr_svc_not_found = /** @type {(inputs: Svc_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service introuvable !`)
};

const pt_svc_not_found = /** @type {(inputs: Svc_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serviço não encontrado!`)
};

const zh_svc_not_found = /** @type {(inputs: Svc_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务未找到！`)
};

const tr_svc_not_found = /** @type {(inputs: Svc_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hizmet Bulunamadı!`)
};

const ru_svc_not_found = /** @type {(inputs: Svc_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сервис не найден!`)
};

const pl_svc_not_found = /** @type {(inputs: Svc_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono usługi!`)
};

/**
* | output |
* | --- |
* | "Service Not Found!" |
*
* @param {Svc_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_not_found = /** @type {((inputs?: Svc_Not_FoundInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Not_FoundInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_not_found(inputs)
	if (locale === "bn") return bn_svc_not_found(inputs)
	if (locale === "de") return de_svc_not_found(inputs)
	if (locale === "es") return es_svc_not_found(inputs)
	if (locale === "fr") return fr_svc_not_found(inputs)
	if (locale === "pt") return pt_svc_not_found(inputs)
	if (locale === "zh") return zh_svc_not_found(inputs)
	if (locale === "tr") return tr_svc_not_found(inputs)
	if (locale === "ru") return ru_svc_not_found(inputs)
	if (locale === "pl") return pl_svc_not_found(inputs)
	return en_svc_not_found(inputs)
});